import React, { FC } from 'react';
import { UitkExpandoList, UitkExpandoListItem } from 'uitk-react-expando';
import { UitkSpacingHr } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import Sidebar from '../sidebar/sidebar';
import useLocale from '../../hooks/useLocale';
import useSideBarVisibility from '../../hooks/useSideBarVisiblity';

const MobileSidebarBody: FC = () => (
  <>
    <UitkSpacingHr />
    <Sidebar />
  </>
);

const MobileSidebarTitle: FC<{ label: string }> = ({ label }) => (
  <div className="sidebar-mobile-title">
    <UitkText weight="medium">{label}</UitkText>
  </div>
);

const MobileSidebar: FC<{ hideSideBar: boolean }> = ({ hideSideBar = false }) => {
  const { formatContent } = useLocale();
  const { expandMobileSideBarMenu, toggleMobileSideBarMenu } = useSideBarVisibility();

  return (
    <div className={hideSideBar ? 'sidebar-mobile-hidden' : ''}>
      <UitkExpandoList>
        <UitkExpandoListItem
          onToggle={toggleMobileSideBarMenu}
          expandoDescription={<MobileSidebarBody />}
          triggerPosition="trailing"
          isVisible={expandMobileSideBarMenu}
          expandoTitle={<MobileSidebarTitle label={formatContent('menu', 'Menu')} />}
          isIndented={false}
          className="sidebar-expando-trigger"
        />
      </UitkExpandoList>
    </div>
  );
};

export default MobileSidebar;
